const styles = {
  pageWrapperSx: {
    px: { xs: 2, sm: 3, md: 5 },
    mt: { xs: 4, md: 10 },
    maxWidth: "1200px",
    mx: "auto",
  },

  imageSx: {
    display: "block",
    objectFit: "cover",
    backgroundColor: "#1a1a1a",
    borderRadius: "10px",
    float: { xs: "none", md: "left" },
    width: { xs: "65%", sm: "55%", md: "45%" },
    maxWidth: { xs: "300px", md: "480px" },
    marginLeft: { xs: "auto", md: 0 },
    marginRight: { xs: "auto", md: 4 },
    mb: { xs: 3, md: 3 },
  },

  titleSx: {
    textAlign: { xs: "center", md: "left" },
    mb: 2,
    color: "white",
  },

  metaRowSx: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: { xs: "center", md: "flex-start" },
    gap: 2,
    mb: 2,
  },

  metaItemSx: { display: "flex", alignItems: "center", gap: 1 },

  priceRowSx: {
    display: "flex",
    alignItems: "center",
    gap: 1,
    justifyContent: { xs: "center", md: "flex-start" },
    mb: 1,
  },

  timeRowSx: {
    display: "flex",
    alignItems: "center",
    gap: 1,
    justifyContent: { xs: "center", md: "flex-start" },
    mb: 2,
  },

  genresRowSx: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: { xs: "center", md: "flex-start" },
    gap: 1,
    mb: 2,
  },

  iconSx: { color: "#c7c7c7", fontSize: 18 },

  descriptionSx: {
    textAlign: { xs: "center", md: "left" },
    color: "white",
    mt: 5,
    fontSize: 15,
    lineHeight: 1.7,
    "& p": { marginBottom: "1em", textAlign: "inherit" },
    "& ul, & ol": {
      paddingLeft: "1.5em",
      paddingRight: { xs: "1.5em", md: 0 },
      marginBottom: "1em",
    },
    "& strong": { fontWeight: 600 },
    "& em": { fontStyle: "italic" },
    "& *": { color: "inherit" },
  },

  clearSx: { clear: "both" },

  metaTextSx: { color: "white" },
};

export default styles;
